import React from "react";

export default function Downloads() {
  return <div>Downloads section yet to be developed</div>;
}
